export default __webpack_public_path__ + "static/media/doctor.2dcddf3a.png";